import axios from 'axios';
import { baseURL as apiPath } from '../config';

const methods = ['get', 'post', 'put', 'patch', 'delete'];

export function formatUrl(path) {
  const adjustedPath = path[0] !== '/' ? `/${path}` : path;
  return apiPath + adjustedPath;
}

export function checkStatus(response) {
  if (response.data.code === 0) {
    return response.data;
  }
  return Promise.reject(response);
}

function fetchCreator(method, url, options = {}) {
  options.method = method;

  return this.request(url, options).then(checkStatus);
}

class ApiClient {
  constructor() {
    methods.forEach((method) => {
      this[method] = fetchCreator.bind(this, method);
    });
  }

  request(url, { data, ...options } = {}) {
    const fetchOptions = options;
    fetchOptions.headers = fetchOptions.headers || {};
    fetchOptions.headers['Accept'] = 'application/json';

    // todo: چک علت آبجکت خالی شدن فورم دیتا
    if (data)
      if (fetchOptions.type === 'formData')
        data = Object.keys(data).reduce((total, key) => {
          total.append(key, data[key]);
          return total;
        }, new FormData());

    if (this.token) fetchOptions.headers.t = this.token;

    const instance = axios.create({
      baseURL: apiPath,
      headers: fetchOptions.headers,
      validateStatus: () => true,
    });
    if (data) return instance[options.method](formatUrl(url), data);

    return instance[options.method](formatUrl(url));
  }
}
const apiClient = new ApiClient();

export { apiClient };
